import React from 'react';

const DolibarrSettingsModal = ({
  open,
  onClose,
  alertVariant,
  status,
  lastSync,
  loading,
  url,
  setUrl,
  apiKey,
  setApiKey,
  loaded,
  onConnect
}) => {
  if (!open) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Configurar Dolibarr</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="text-muted">URL de la API y API Key para sincronizar clientes, facturas y presupuestos.</p>
            {status && (
              <div className={`alert alert-${alertVariant(status.type)}`}>
                {status.message}
              </div>
            )}
            {lastSync && <div className="alert alert-info">Última sincronización: {new Date(lastSync).toLocaleString()}</div>}
            <form onSubmit={onConnect}>
              <div className="mb-3">
                <label className="form-label">URL de Dolibarr</label>
                <input
                  type="url"
                  className="form-control"
                  placeholder="https://tu-dolibarr.com/api/index.php"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">API Key</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="API Key"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                  required={!loaded}
                  disabled={loading}
                />
              </div>
              <div className="d-flex gap-2">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Conectando...' : 'Guardar credenciales'}
                </button>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DolibarrSettingsModal;
